// ----------------------------------------------------------------------
// <copyright file="polyfill.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

if (typeof Object.assign != 'function') {
  (function() {
    Object.assign = function(target) {
      'use strict';
      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var output = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var source = arguments[index];
        if (source !== undefined && source !== null) {
          for (var nextKey in source) {
            if (source.hasOwnProperty(nextKey)) {
              output[nextKey] = source[nextKey];
            }
          }
        }
      }
      return output;
    };
  })();
}

if (Function.prototype.name === undefined && Object.defineProperty !== undefined) {
  Object.defineProperty(Function.prototype, 'name', {
    get: function() {
      var funcNameRegex = /function\s([^(]{1,})\(/;
      var results = funcNameRegex.exec(this.toString());
      return results && results.length > 1 ? results[1].trim() : '';
    },
    set: function(value) {}
  });
}

if (typeof window.CustomEvent !== 'function') {
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
}

if (typeof window.Map !== 'function') {
  function Map(iterable) {
    const _items = [];
    const _keys = [];
    const _values = [];
  
    // Object.is polyfill, courtesy of @WebReflection
    const is = Object.is || function(a, b) {
        return a === b ?
            a !== 0 || 1 / a == 1 / b :
            a != a && b != b;
    };
  
    // More reliable indexOf, courtesy of @WebReflection
    const betterIndexOf = function(value) {
        if(value != value || value === 0) {
            for(var i = this.length; i-- && !is(this[i], value););
        } else {
            i = [].indexOf.call(this, value);
        }
        return i;
    };
  
    /**
     * MapIterator used for iterating over all entries in given map.
     *
     * @param map {Map} to iterate
     * @param kind {String} identifying what to yield. Possible values
     *      are 'keys', 'values' and 'keys+values'
     * @constructor
     */
    const MapIterator = function MapIterator(map, kind) {
        let _index = 0;
  
        return Object.create({}, {
            next: {
                value: function() {
                    // check if index is within bounds
                    if (_index < map.items().length) {
                        switch(kind) {
                            case 'keys': return map.keys()[_index++];
                            case 'values': return map.values()[_index++];
                            case 'keys+values': return [].slice.call(map.items()[_index++]);
                            default: throw new TypeError('Invalid iterator type');
                        }
                    }
                    // TODO: make sure I'm interpreting the spec correctly here
                    throw new Error('Stop Iteration');
                }
            },
            iterator: {
                value: function() {
                    return this;
                }
            },
            toString: {
                value: function() {
                    return '[object Map Iterator]';
                }
            }
        });
    };
  
    const _set = function(key, value) {
        // check if key exists and overwrite
        var index = betterIndexOf.call(_keys, key);
        if (index > -1) {
            _items[index][1] = value;
            _values[index] = value;
        } else {
            _items.push([key, value]);
            _keys.push(key);
            _values.push(value);
        }
    };
  
    const setItem = function(item) {
        if (item.length !== 2) {
            throw new TypeError('Invalid iterable passed to Map constructor');
        }
  
        _set(item[0], item[1]);
    };
  
    // FIXME: accommodate any class that defines an @@iterator method that returns
    //      an iterator object that produces two element array-like objects
    if (Array.isArray(iterable)) {
        iterable.forEach(setItem);
    } else if (iterable !== undefined) {
        throw new TypeError('Invalid Map');
    }
  
    return Object.create(MapPrototype, {
        /**
         * @return {Array} all entries in the Map, in order
         */
        items:{
            value:function() {
                return [].slice.call(_items);
            }
        },
        /**
         * @return {Array} all keys in the Map, in order
         */
        keys:{
            value:function() {
                return [].slice.call(_keys);
            }
        },
        /**
         * @return {Array} all values in the Map, in order
         */
        values:{
            value:function() {
                return [].slice.call(_values);
            }
        },
        /**
         * Given a key, indicate whether that key exists in this Map.
         *
         * @param key {Object} expected key
         * @return {Boolean} true if key in Map
         */
        has:{
            value:function(key) {
                // TODO: double-check how spec reads about null values
                var index = betterIndexOf.call(_keys, key);
                return index > -1;
            }
        },
        /**
         * Given a key, retrieve the value associated with that key (or undefined).
         *
         * @param key {Object}
         * @return {Object} value associated with key or undefined
         */
        get:{
            value:function(key) {
                var index = betterIndexOf.call(_keys, key);
                return index > -1 ? _values[index] : undefined;
            }
        },
        /**
         * Add or overwrite entry associating key with value. Always returns undefined.
         *
         * @param key {Object} anything
         * @param value {Object} also anything
         */
        set:{
            value: _set
        },
        /**
         * Return the number of entries in this Map.
         *
         * @return {Number} number of entries
         */
        size:{
            get:function() {
                return _items.length;
            }
        },
        /**
         * Remove all entries in this Map. Returns undefined.
         */
        clear:{
            value:function() {
                _keys.length = _values.length = _items.length = 0;
            }
        },
        /**
         * Delete entry with given key, if it exists.
         *
         * @param key {Object} any possible key
         * @return {Boolean} true if an entry was deleted
         */
        'delete':{
            value:function(key) {
                const index = betterIndexOf.call(_keys, key);
                if (index > -1) {
                    _keys.splice(index, 1);
                    _values.splice(index, 1);
                    _items.splice(index, 1);
                    return true;
                }
                return false;
            }
        },
        /**
         * Given a callback function and optional context, invoke the callback on all
         * entries in this Map.
         *
         * @param callbackFn {Function}
         */
        forEach:{
            value:function(callbackfn /*, thisArg*/) {
                if (typeof callbackfn != 'function') {
                    throw new TypeError('Invalid callback function given to forEach');
                }
  
                function tryNext() {
                    try {
                        return iter.next();
                    } catch(e) {
                        return undefined;
                    }
                }
  
                let iter = this.iterator();
                let current = tryNext();
                let next = tryNext();
                while(current !== undefined) {
                    callbackfn.apply(arguments[1], [current[1], current[0], this]);
                    current = next;
                    next = tryNext();
                }
            }
        },
        /**
         * Return a MapIterator object for this map.
         */
        iterator:{
            value: function() {
                return new MapIterator(this, 'keys+values');
            }
        },
        toString:{
            value: function() {
                return '[Object Map]';
            }
        }
    });
  }

  let MapPrototype = Map.prototype;
  Map.prototype = MapPrototype = Map();
  window.Map = window.Map || Map;
}

if (!String.prototype.includes) {
  Object.defineProperty(String.prototype, 'includes', {
    value: function (search, start) {
      if (typeof start !== 'number') {
        start = 0;
      }

      if (start + search.length > this.length) {
        return false;
      }
      return this.indexOf(search, start) !== -1;
    }
  });
}


// WEBPACK FOOTER //
// ./ui/share/utils/polyfill.js